var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24True(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-_true",
    "data-name": "icon-24- true",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M5.724,15.857a1.087,1.087,0,0,0,1.585,0L20.035,3.131a1.132,1.132,0,0,0,0-1.608l-1.2-1.2a1.132,1.132,0,0,0-1.585,0L6.517,11.057,3.12,7.683a1.087,1.087,0,0,0-1.585,0l-1.2,1.2a1.132,1.132,0,0,0,0,1.608Z",
    transform: "translate(2 4)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24True);
export default __webpack_public_path__ + "static/media/icon-24- true.6e22027d2acc15da487c243646bc349d.svg";
export { ForwardRef as ReactComponent };